<template>
  <div>
    <v-text-field label="انتخاب دسته بندی" :value="product_name" :hide-details="errors === undefined"
                  outlined readonly append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true"
                  :disabled="disabled" @click:clear="$emit('categoryPicker', null)" :clearable="clearable" ref="input"
                  :error-messages="errors"/>

    <v-dialog v-model="dialog" scrollable max-width="800px">
      <v-card elevation="2" outlined :loading="loading">
        <v-card-title>انتخاب دسته بندی</v-card-title>
        <v-divider></v-divider>

        <v-card-actions>
          <v-text-field label="جستجو" append-icon="mdi-magnify"
                        v-model="search" outlined @change="fetch"
                        hide-details class="my-3"/>
        </v-card-actions>

        <v-list>
          <v-list-item @click="pick(x)" v-for="(x,i) in categories.data" :key="i">
            <v-list-item-avatar>
              <v-avatar>
                <v-img :src="x.image || `${$config.baseURL}/image/noData.svg`"/>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="x.name || x.sku"/>
            </v-list-item-content>

            <v-list-item-action v-if="x.category_id === value">
              <v-icon>mdi-check</v-icon>
            </v-list-item-action>

            <v-list-item-action-text v-text="`${x.products_count} محصول `"/>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <pagination :data="categories" :visible="2" v-on:page="fetch"/>

          <v-spacer/>

          <v-btn color="primary" class="mr-auto" text @click="dialog = false">بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "categoryPicker",

  props: ['value', 'errors', 'clearable', 'disabled'],

  model: {
    prop: 'value',
    event: 'categoryPicker'
  },

  computed: {
    product_name: function () {
      if (this.model === null) return "";
      return this.model.name;
    }
  },

  data: () => ({
    dialog: false,
    loading: false,
    search: null,
    categories: [],
    model: null,
  }),

  watch: {
    value: function () {
      this.findModel();
    }
  },

  created() {
    this.findModel();
    this.fetch();
  },

  methods: {
    fetch(page = 1) {
      this.requestApiGet('categories', {
        params: {
          search: this.search,
          page: page
        }
      })
        .then(({data}) => this.categories = data)
        .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
        .finally(() => this.loading = false);
    },
    findModel() {
      if (this.value == null) return;

      this.loading = true;

      this.requestApiGet(`categories/${this.value}`)
        .then(({data}) => this.model = data)
        .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
        .finally(() => this.loading = false);
    },
    pick(x) {
      this.$emit('categoryPicker', x.category_id);
      this.model = x;
      this.dialog = false;
    }
  }
}
</script>

<style scoped>

</style>
